<template>
  <panel title="Tipo, Condição e Envio">
    <div class="l-row">
      <form-group label="Condição" :columns="4" :required="true">
        <select class="form-select" v-model="product.condition">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="condition in category.settings.item_conditions" :key="condition" :value="condition">{{ $t(`mercadoLivre.conditions.${condition}.label`) }}</option>
        </select>
      </form-group>

      <form-group label="Tipo checkout">
        <label class="form-switch">
          <input type="checkbox" v-model="typeCheckout">
          <span class="form-switch__indicator"></span>
        </label>
        <small class="form-help">Define se o anúncio será do tipo "checkout" para usar buybox.</small>
      </form-group>

      <form-group style="visibility: hidden;" label="Envio" :columns="4" :required="true">
        <select class="form-select" v-model="product.shippingMode" @change="onChangeShippingOption(product.shippingMode)">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="shippingOption in category.settings.shipping_options" :key="shippingOption" :value="shippingOption">{{ $t(`mercadoLivre.shippingOptions.${shippingOption}.label`) }}</option>
        </select>
      </form-group>

      <general-shipping-rules v-for="announcementConfiguration in configurations" :accountQuantity="accountQuantity" :product="product" :announcementConfiguration="announcementConfiguration" :selectedShippingOption="selectedShippingOption" v-on:loading="l => { this.loading =  l }"/>

    </div>
  </panel>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import GeneralShippingRules from '@/components/marketplace/mercadoLivre/announcement/general/ShippingRules'

  export default {
    data: () => ({
      typeCheckout: false,
      loading: false,
      configurations: [],
      selectedShippingOption: '',
      accountQuantity: 0
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      category: {
        type: Object,
        required: true
      },
      defaultTypeCheckout: {
        type: Boolean,
        default: false
      },
      announcementConfigurations: {
        type: Array,
        required: true
      }
    },
    created () {
      this.typeCheckout = this.defaultTypeCheckout
      this.selectedShippingOption = this.product.shippingMode
      this.product.condition = null

      this.configurations.splice(0, this.configurations.length)

      for (const d of this.announcementConfigurations) {
        if (d.account) {
          if (this.configurations.some(configuration => configuration.account.id === d.account.id)) {
            continue
          }
          this.configurations.push(d)
        }
      }
      this.accountQuantity = this.configurations.length

      if (!this.product.type) {
        this.product.type = 'free'
      }

      const conditionIndex = this.category.settings.item_conditions.indexOf('new')
      if (conditionIndex !== -1) {
        this.product.condition = this.category.settings.item_conditions[conditionIndex]
      }

      let shippingModeIndex = this.category.settings.shipping_modes.indexOf('me2')
      if (this.product.shippingMode) {
        const index = this.category.settings.shipping_modes.indexOf(this.product.shippingMode)

        if (index !== -1) {
          shippingModeIndex = this.category.settings.shipping_modes.indexOf(this.product.shippingMode)
        }
      }

      if (shippingModeIndex !== -1) {
        this.product.shippingMode = this.category.settings.shipping_modes[shippingModeIndex]
      }
    },
    methods: {
      onChangeShippingOption (option) {
        this.selectedShippingOption = option
      }
    },
    watch: {
      async typeCheckout (value) {
        this.$emit('changeTypeCheckout', value)

        if (value && this.product.variations.length === 1 && this.product.variations[0].attributes['GTIN'] === null) {
          this.typeCheckout = false
        } else {
          try {
            this.productCatalog = await api.mercadoLivre.getProductCatalog(this.product.variations[0].attributes['GTIN'])
            this.product.productCatalogId = this.productCatalog.id
          } catch (e) {
            notifier.warning('Nenhum produto foi encontrado no catálogo do Mercado Livre com esse EAN.', 'Produto não encontrado')
            this.$emit('changeTypeCheckout', false)
            this.typeCheckout = false
          }
        }
      },
      defaultTypeCheckout (value) {
        this.typeCheckout = value
      },
      announcementConfigurations: {
        handler: function (value) {
          this.configurations.splice(0, this.configurations.length)
          for (const d of value) {
            if (d.account) {
              if (this.configurations.some(configuration => configuration.account.id === d.account.id)) {
                continue
              }
              this.configurations.push(d)
              this.accountQuantity = this.configurations.length
            }
          }
        },
        deep: true
      },
      'configuration.shippingFree': {
        handler: function (value) {
          this.configurations.splice(0, this.configurations.length)
          for (const d of value) {
            if (d.account) {
              if (this.configurations.some(configuration => configuration.account.id === d.account.id)) {
                continue
              }
              this.configurations.push(d)
              this.accountQuantity = this.configurations.length
            }
          }
        },
        deep: true
      }
    },
    components: {
      Panel,
      FormGroup,
      GeneralShippingRules
    }
  }
</script>



// WEBPACK FOOTER //
// Details.vue?84092e28